// Header.js
import React, { useRef, useState, useEffect } from "react";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MessageIcon from '@mui/icons-material/Message';
import { useNavigate } from 'react-router-dom';



function Header({ logo, handleLogout }) {

    const navigate = useNavigate();

    const [showPopup, setShowPopup] = useState(false);
    const [showMessagesPopup, setShowMessagesPopup] = useState(false);
    const [time, setTime] = useState(new Date());
    const [userInfoOpen, setuserInfoopen] = useState(false);
    const dropdownRef = useRef(null);
    const [getuserTypes, setUserType] = useState(localStorage.getItem("usertype") || ''); // Get user type from localStorage or set default value

    const getuserType = localStorage.getItem("usertype");
    


    useEffect(() => {
        const fetchTime = async () => {
            try {
                const response = await fetch("https://ugpapi.mgu.ac.in/api/College/getServerTime");
                if (response.ok) {
                    const data = await response.json(); // Parse the API response as JSON
                    const utcDate = new Date(data.server_time); // Convert the UTC time string to a Date object

                    // Convert UTC to IST
                    // const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC + 5:30
                    // const istDate = new Date(utcDate.getTime() + istOffset);
                    setTime(utcDate); // Set the initial IST time
                } else {
                    console.error("Error fetching server time:", response.status);
                }
            } catch (error) {
                console.error("Error fetching server time:", error);
            }
        };

        fetchTime(); // Fetch the initial time from the API
        // Increment time locally every second
        const localInterval = setInterval(() => {
            setTime((prevTime) => {
                if (!prevTime) return null; // Ensure time is available before incrementing
                return new Date(prevTime.getTime() + 1000); // Increment the time by 1 second
            });
        }, 1000);

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                // Fetch time again when the tab becomes active
                fetchTime();
            }
        };

        // Attach visibility change event listener
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            clearInterval(localInterval); // Cleanup interval on component unmount
            document.removeEventListener("visibilitychange", handleVisibilityChange); // Cleanup event listener
        };
    }, []);

    const handleChangePassword = () => {

        const userType = localStorage.getItem("usertype");



        if (userType == 1) {
            navigate("/admin/adminChangePassword");
        }

        else if (userType == 2) {
            navigate("/college/changepassword");
        }
        else if (userType == 15) {
            navigate("/bos/BOSChangePassword");
        }
        else if (userType == 22) {
            navigate("/sfa/sfachangepassword");
        }
        else {
            alert("Invalid user type. Cannot navigate to change password page.");
        }


    };

    const toggleUserinfo = () => {
        setShowPopup(!showPopup);
        //setuserInfoopen((prev) => !prev);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                //setuserInfoopen(false);
                setShowPopup(false);
            }
        };

        if (showPopup) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPopup]);

    return (
        <div className="top-bar bg-light shadow py-2 position-relative" style={{ height: "65px" }}>
            <div className="container-fluid position-relative">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <img src={logo} alt="Logo" style={{ width: '100%', maxWidth: '180px' }} />
                    </div>
                    <div className="col-md-6 text-end justify-content-end align-items-center cd-lbl-sh-hd">
                        <div className="text-dark text-decoration-none position-relative "
                            ref={dropdownRef} >
                            <AccountCircleIcon className="username-icn clg-icn-clr1" style={{ cursor: 'pointer', marginTop: '11px' }}
                                onClick={toggleUserinfo}
                            />
                            <div className="pdg9 clg-mgs-wt"> {localStorage.getItem('username')}
                                <br /><div className="text-white badge bg-primary text-wrap " style={{ fontSize: '13px;' }}>{time ? (
                                    <>
                                        {time.toLocaleDateString("en-IN", {
                                            day: "numeric",
                                            month: "long",
                                            year: "numeric",
                                        })}
                                        &nbsp;
                                        {time.toLocaleTimeString("en-IN", {
                                            hour: "numeric",
                                            minute: "numeric",
                                            second: "numeric",
                                            hour12: true,
                                        })}
                                    </>
                                ) : (
                                    <>Loading...</>
                                )}</div>
                            </div>

                            {showPopup && (
                                <div className="popup-box popup-box-li top-100 end-0"

                                >
                                    {getuserType !== "22" && (
                                        <div
                                            className="dropdown-item dropdown-item-li d-flex align-items-center"
                                            onClick={handleChangePassword} // Replace with your function
                                            style={{ cursor: 'pointer', padding: '10px 0px' }}
                                        >
                                            <i className="fas fa-key fa-sm fa-fw me-2"></i>
                                            Change Password
                                        </div>
                                    )}

                                    <div
                                        className="dropdown-item dropdown-item-li d-flex align-items-center"
                                        onClick={handleLogout}
                                        style={{ cursor: 'pointer', padding: '10px 0px' }}
                                    >
                                        <i className="fas fa-sign-out-alt fa-sm fa-fw me-2"></i>
                                        Logout
                                    </div>
                                </div>
                            )}

                        </div>
                        <div
                            className="text-dark text-decoration-none position-relative me-4"
                            onMouseEnter={() => setShowMessagesPopup(true)}
                            onMouseLeave={() => setShowMessagesPopup(false)}
                        >
                            <MessageIcon className="username-icn icn-fn-sz clg-icn-clr2" aria-hidden="true" />
                            {showMessagesPopup && (
                                <div className="messages-popup">
                                    <div className="title-message1">Messages</div>
                                    <ul style={{ padding: "15px" }}>
                                        <li className="b-l-primary border-4 newstyle">
                                            <p>You currently have no messages.</p>
                                        </li>
                                    </ul>
                                    <div className="card-footer text-center" style={{ borderRadius: "5px" }}>
                                        <a className="text-decoration-none">CHECK ALL</a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;